<template>
    <div class="pt-0 pb-4 px-6">
        <v-alert type="error" v-if="notAuthorized">
            {{ $t('forms.not_authorized') }}
        </v-alert>
        <v-alert type="error" v-if="networkError">
            {{ $t('globals.network_error') }}
        </v-alert>

        <GeneralForm
            ref="form"
            v-show="!loading"
            v-model="localCompany"
            @submit="submit"
            :disabled="loading"
            :isFormValid.sync="isFormValid"
        >
            <template #submit>
                <div class="d-flex justify-end">
                    <v-btn type="submit" color="primary" depressed class="action-button" :loading="loading" :disabled="!isFormValid">
                        {{ $t('actions.save') }}
                    </v-btn>
                </div>
            </template>
        </GeneralForm>
    </div>
</template>

<script>
import HasErrorHandlerMixin from '@/mixins/HasErrorHandlerMixin'
import GeneralForm from '@/components/forms/GeneralForm'
import Company from '@/models/Company'
import { mapGetters } from 'vuex'

export default {
    name: 'General',
    components: {
        GeneralForm,
    },
    mixins: [ HasErrorHandlerMixin ],
    data: vm => ({
        localCompany: new Company,

        loading: false,
        notAuthorized: false,
        isFormValid: false,
        networkError: false
    }),
    created() {
        this.cloneCompany()
    },
    async mounted() {
        this.$emit('update-is-completed', await this.$refs.form.validate())
    },
    methods: {
        cloneCompany() {
            this.localCompany = new Company(this.$lodash.cloneDeep(this.company))
        },
        async submit(company) {
            this.networkError = false
            company.formatToBack()

            this.loading = true
            this.notAuthorized = false
            let res = await company.update(['name', 'document'])
                .catch(this.preErrorHandler)

            if (!res)
                return

            await this.$store.dispatch('company/fetchData')
            this.cloneCompany()
            this.loading = false
            this.$emit('update-is-completed', this.isFormValid)

            this.$bus.$emit('message', this.$t('views.companies.parent.Personalize.alerts.success'), 'success')
        },
        preErrorHandler(e) {
            if (e.message == 'Network Error')
                this.networkError = true

            let status = this.$lodash.get(e, 'response.status')

            if (status == 403) {
                this.notAuthorized = true
            }

            this.errorHandler(e)
        },
    },
    computed: {
        ...mapGetters({
            company: 'company/state',
        }),
    },
}
</script>